import { translateString } from '@src/util/intl/translateString';

import { isTriggerVisibleToUser } from './isTriggerVisibleToUser';
import {
  findMatchingTrigger,
  getEventTriggerKeys,
  getMatchingTriggerProgressLabel,
  getTriggerMatchKeys,
  getTriggerProgressLabel,
  matchesTriggerKeys,
} from './progress';

export const getCompletitionData = (triggers = []) => {
  const data = triggers.reduce(
    (accumulator, trigger) => ({
      expectedExecutions: accumulator.expectedExecutions + (trigger?.expectedExecutions || 0),
      finishedExecutions:
        accumulator.finishedExecutions +
        (Math.max(0, Math.min(trigger?.expectedExecutions, trigger?.finishedExecutions || 0)) || 0),
    }),
    {
      expectedExecutions: 0,
      finishedExecutions: 0,
    },
  );

  const finishedPercentage = Math.min(
    (data.finishedExecutions / data.expectedExecutions) * 100 || 0,
    100,
  );

  return { ...data, finishedPercentage };
};

export const addOrderToTriggers = (triggers = []) => {
  const triggersParsed = triggers.reduce((acc, item, index) => {
    acc.push({
      ...item,
      order: index + 1,
    });
    return acc;
  }, []);
  return triggersParsed;
};
export const removeOrderFromTriggers = (triggers = []) => {
  const triggersWithoutOrder = triggers.map(trigger => {
    const { order, ...triggerWithoutOrder } = trigger;
    return triggerWithoutOrder;
  });
  return triggersWithoutOrder;
};

export const getTriggerStatus = trigger => {
  const percentage = (trigger.finishedExecutions / trigger.expectedExecutions) * 100;

  if (percentage >= 100) {
    return {
      label: translateString('dashboards.schedules.triggerProgress.done'),
      color: 'success',
    };
  } else {
    return {
      label: translateString('dashboards.schedules.triggerProgress.inProgress'),
      color: 'processing',
    };
  }
};

/** Aggregate completion from a trigger list; null when empty. */
export const getTriggersCompletion = (triggers) => {
  if (!Array.isArray(triggers) || triggers.length === 0) {
    return null;
  }

  return getCompletitionData(
    triggers.map(trigger => ({
      expectedExecutions: Math.max(trigger.expectedExecutions || 1, 1),
      finishedExecutions: trigger.finishedExecutions || 0,
    })),
  );
};

/**
 * Schedule/execution totalizer label (`n/m`).
 * Prefer live list aggregation; fall back to a denormalized trigger when needed.
 */
export const getTriggersProgressLabel = (triggers, fallback) => {
  const completion = getTriggersCompletion(triggers);
  if (completion) {
    return getTriggerProgressLabel(completion);
  }

  return getTriggerProgressLabel(fallback);
};

export {
  findMatchingTrigger,
  getEventTriggerKeys,
  getMatchingTriggerProgressLabel,
  getTriggerMatchKeys,
  getTriggerProgressLabel,
  isTriggerVisibleToUser,
  matchesTriggerKeys,
};
